module.exports = __webpack_public_path__ + "media/components/VendingCart/assets/extensions-thumbnail/right-table-b3d73f092b9774bce56007d0acba9be6.png";